import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services/authentication.service'
import { Menu, subMenu } from '../interfaces/menu.interface';



@Injectable()
export class MenuService extends AuthenticationService {

    private _Menu : any;

    constructor() {    
        super();
            console.log(this.userData);
        this.onMenuCreate(this.userData)

    }

    onMenuCreate(data){

        
    }
    
    
}